import React, { useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface HtmlEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

export const HtmlEditor: React.FC<HtmlEditorProps> = ({
  value,
  onChange,
  placeholder = 'Enter description...',
  disabled = false,
  className = '',
}) => {
  const quillRef = useRef<ReactQuill>(null);

  const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'color': [] }, { 'background': [] }],
      ['link'],
      ['clean']
    ],
  };

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet',
    'color', 'background',
    'link'
  ];

  return (
    <div className={`html-editor-wrapper ${className}`}>
      <style>{`
        .html-editor-wrapper .ql-container {
          min-height: 200px;
          font-size: 14px;
        }
        .html-editor-wrapper .ql-editor {
          min-height: 200px;
        }
        .html-editor-wrapper .ql-toolbar {
          border-top-left-radius: 0.5rem;
          border-top-right-radius: 0.5rem;
          border: 1px solid #d1d5db;
        }
        .html-editor-wrapper .ql-container {
          border-bottom-left-radius: 0.5rem;
          border-bottom-right-radius: 0.5rem;
          border: 1px solid #d1d5db;
        }
        .dark .html-editor-wrapper .ql-toolbar {
          background-color: #374151;
          border-color: #4b5563;
        }
        .dark .html-editor-wrapper .ql-container {
          background-color: #1f2937;
          border-color: #4b5563;
        }
        .dark .html-editor-wrapper .ql-editor {
          color: #f9fafb;
        }
        .dark .html-editor-wrapper .ql-stroke {
          stroke: #d1d5db;
        }
        .dark .html-editor-wrapper .ql-fill {
          fill: #d1d5db;
        }
        .dark .html-editor-wrapper .ql-picker-label {
          color: #d1d5db;
        }
        .html-editor-wrapper .ql-toolbar.ql-snow {
          border-top: 1px solid #d1d5db;
          border-left: 1px solid #d1d5db;
          border-right: 1px solid #d1d5db;
        }
        .html-editor-wrapper .ql-container.ql-snow {
          border-bottom: 1px solid #d1d5db;
          border-left: 1px solid #d1d5db;
          border-right: 1px solid #d1d5db;
        }
      `}</style>
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        readOnly={disabled}
      />
    </div>
  );
};

















